import React from 'react';
import { ClockModel } from 'shared/types';
import { formatTime } from 'utils/date-utils';
import { CLOCK_COLORS, StatGrid, StatCard, StatValue, StatLabel } from './styles';

type Props = {
  model: ClockModel;
};

const pct = (part: number, total: number): string =>
  total > 0 ? `${Math.round((part / total) * 100)}%` : '—';

const SessionStats: React.FC<Props> = ({ model }): JSX.Element => {
  const { totalSec } = model;
  return (
    <StatGrid>
      <StatCard>
        <StatValue>{formatTime(totalSec)}</StatValue>
        <StatLabel>Total time</StatLabel>
      </StatCard>
      <StatCard>
        <StatValue $color={CLOCK_COLORS.active}>{formatTime(model.activeSec)}</StatValue>
        <StatLabel>Active learning · {pct(model.activeSec, totalSec)}</StatLabel>
      </StatCard>
      <StatCard>
        <StatValue $color={CLOCK_COLORS.idle}>{formatTime(model.idleSec)}</StatValue>
        <StatLabel>Idle · {pct(model.idleSec, totalSec)}</StatLabel>
      </StatCard>
      <StatCard>
        <StatValue>{formatTime(model.lobbySec)}</StatValue>
        <StatLabel>Lobby / loading · {pct(model.lobbySec, totalSec)}</StatLabel>
      </StatCard>
      <StatCard>
        <StatValue>{model.stationCount}</StatValue>
        <StatLabel>Stations visited</StatLabel>
      </StatCard>
      <StatCard>
        <StatValue>
          {model.correctCount}/{model.answerCount}
        </StatValue>
        <StatLabel>Questions correct</StatLabel>
      </StatCard>
    </StatGrid>
  );
};

export default SessionStats;
